<div class="custom-paginator" *ngIf="totalPages > 1">
  <div class="pagination-container">
    
    <!-- First Page Button -->
    <button 
      *ngIf="showFirstLast"
      type="button" 
      class="page-btn first-btn"
      [disabled]="!canGoFirst()"
      (click)="goToFirst()"
      title="First Page">
      ⏮️
    </button>
    
    <!-- Previous Page Button -->
    <button 
      *ngIf="showPrevNext"
      type="button" 
      class="page-btn prev-btn"
      [disabled]="!canGoPrevious()"
      (click)="goToPrevious()"
      title="Previous Page">
      ◀️
    </button>
    
    <!-- Page Numbers and Ellipsis -->
    <ng-container *ngFor="let page of visiblePages; trackBy: trackByPage">
      
      <!-- Ellipsis -->
      <span 
        *ngIf="isEllipsis(page)" 
        class="ellipsis">
        {{ page }}
      </span>
      
      <!-- Page Number -->
      <button 
        *ngIf="isNumber(page)"
        type="button" 
        class="page-btn number-btn"
        [class.active]="isCurrentPage(page)"
        [disabled]="isCurrentPage(page)"
        (click)="goToPage(page)"
        [title]="'Go to page ' + page">
        {{ page }}
      </button>
      
    </ng-container>
    
    <!-- Next Page Button -->
    <button 
      *ngIf="showPrevNext"
      type="button" 
      class="page-btn next-btn"
      [disabled]="!canGoNext()"
      (click)="goToNext()"
      title="Next Page">
      ▶️
    </button>
    
    <!-- Last Page Button -->
    <button 
      *ngIf="showFirstLast"
      type="button" 
      class="page-btn last-btn"
      [disabled]="!canGoLast()"
      (click)="goToLast()"
      title="Last Page">
      ⏭️
    </button>
    
  </div>
  
  <!-- Page Info -->
  <div *ngIf="pageInfo" class="page-info">
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
  </div>
</div>
